import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiLogin } from "../api";
import { AppearanceSelect } from "../components/AppearanceSelect";
import { AppBrandTagline } from "../components/AppLogo";
import { PasswordField } from "../components/PasswordField";
import { useAuth } from "../SessionContext";
import { useOAuthQueryMessage } from "../useOAuthQueryMessage";
import { OAuthProviderButtons } from "../components/OAuthProviderButtons";
import { useOAuthProviders } from "../useOAuthProviders";

export function LoginPage() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const oauthError = useOAuthQueryMessage();
  const oauthProviders = useOAuthProviders();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await apiLogin(login, password);
      await refresh();
      navigate("/", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="layout narrow">
      <div className="auth-appearance-row">
        <AppearanceSelect id="appearance-login" />
      </div>
      <h1>Sign in</h1>
      <AppBrandTagline />
      <form className="card" method="post" onSubmit={onSubmit} noValidate>
        <label htmlFor="login-identifier">
          Username or email
          <input
            id="login-identifier"
            name="login"
            type="text"
            autoComplete="username"
            inputMode="text"
            value={login}
            onChange={(e) => setLogin(e.currentTarget.value)}
            placeholder="you@example.com"
            required
          />
        </label>
        <PasswordField
          label="Password"
          value={password}
          onChange={setPassword}
          autoComplete="current-password"
          required
        />
        {oauthError ? <p className="error">{oauthError}</p> : null}
        {error ? <p className="error">{error}</p> : null}
        <button type="submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <OAuthProviderButtons
        googleEnabled={oauthProviders.google}
        appleEnabled={oauthProviders.apple}
        loading={oauthProviders.loading}
        error={oauthProviders.error}
        ariaLabel="Social sign-in"
      />
      <p className="muted">
        <Link to="/signup">Create an account</Link>
        {" · "}
        <Link to="/reset-password">Forgot password</Link>
      </p>
    </div>
  );
}
